import * as React from 'react';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { useAppDispatch, useAppSelector } from '../../../hooks/index';
import { Afr, getSelectedAfr } from '../../../redux/AfrSlice';
import { Entity, getSelectedEntity } from '../../../redux/EntitySlice';
import { AfrEvents, getSelectedEvents } from '../../../redux/EventsSlice';
import { selectUser } from '../../../redux/UserSlice';
import { getTableFacts, getReplaceTableFacts, getTaxonomyType, getDimensionSectionMap } from '../../../redux/MiscSlice';
import {
    AFRError, ErrorSummaryAFRSection, getDisplayErrors, getErrorList,
    getTotalErrorCount, getValidationsForAfr, resetValidationState, Section,
    setDisplayErrors, updateErrors, validateAfr, ValidationContext
} from '../../../redux/ValidationSlice';
import dateHelper from '../../../utils/dateHelper';
import enums from '../../../utils/enums';
import utilityHelper from '../../../utils/utilityHelper';
import NavigationPanelItem from '../../core/NavigationPanelItem';
import notificationIcon from './notificationIcon.svg';
import close from './Close.svg';
import "./stylesbysection.css";
import { TaxonomyTypeEnum } from '../../../redux/TaxonomyVersionSlice';



const NotificationErrorBySections = () => {
    const dispatch = useAppDispatch();

    const user = useAppSelector(selectUser);
    const userRole = user && user.userProfile ? user.userProfile.role : "ENTITY_USER";
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const currentEntity: Entity | null = useAppSelector(getSelectedEntity);
    const currentEvents: AfrEvents | null = useAppSelector(getSelectedEvents);
    const errorList = useAppSelector(getErrorList);
    const displayErrors = useAppSelector(getDisplayErrors);
    const totalErrorCount: number = useAppSelector(getTotalErrorCount);
    const pendingTableFacts = useAppSelector(getTableFacts);
    const pendingReplaceTableFacts = useAppSelector(getReplaceTableFacts);
    const [showNotification, setShowNotification] = useState(false);
    const history = useHistory();
    const taxonomyType: TaxonomyTypeEnum | null = useAppSelector(getTaxonomyType);
    const dmap: any = useAppSelector(getDimensionSectionMap);

    
    interface Error {
        type: string,
        description: string,
        severity: number,
        entityId: string,
        year: string,
        linkTo: string,
        entityType: string, /* 03( section code)  : Balance account,  
                               04_1: Revenues, 04_2: Impact Fees
                               05: Expenditures
                               08: Affiliated Entities*/
        entityCode: string,  /* ex. 512.000 Account if Balance sheet, 
                            301524 if it is an affiliated entity    */
        date: string;
        time: string;
    }

    const paintSeverityIcon = function (severity: number) {
        var info = "bi bi-info-circle-fill text-warning";
        var error = "bi bi-exclamation-triangle-fill text-danger";
        var warning = "bi bi-exclamation-circle-fill text-warning";
        if (severity === 1) {
            return <i className={error}></i>
        }

        if (severity === 2) {
            return <i className={warning}></i>
        }

        if (severity === 3) {
            return <i className={info}></i>
        }


    }

    const getErrorListBySection = function (sectionCode:string) {
        var errorSection = errorList.find((x: any) => x.section.sectionCode === sectionCode);

        if ((typeof errorSection) === "undefined") {
            var emptyArray: Array<Error> = [];
            return emptyArray;
        }

        var list: Array<AFRError> = [...errorSection.errorList];

        var newList: Array<Error> = [];

        // order the list by date descending
        list.sort((a, b) => (a.timeStamp < b.timeStamp) ? 1 : ((b.timeStamp < a.timeStamp) ? -1 : 0));

        for (var err of list) {
            const d = dateHelper.stringToDate(err.timeStamp);
            const time = dateHelper.formatAMPM(d);

            newList.push({
                type: err.type,
                severity: err.severity,
                description: err.description,
                entityId: err.entityId,
                entityType: err.entityType,
                entityCode: err.entityCode,
                year: err.year,
                linkTo: err.linkTo,
                date: dateHelper.stringDateInFormat(err.timeStamp, "LL/dd/yyyy"),
                time: `${time}`,
                })
        }

        return newList;
        
    }


    const toggleNotification = function () {
        setShowNotification(!showNotification);
        dispatch(setDisplayErrors(!showNotification));
    };

    const showErrorSection = function (section: ErrorSummaryAFRSection) {
        var list = getErrorListBySection(section.section.sectionCode);
        var items = [<div></div>];
        for (var err of list) {
            items.push(
                <div key={utilityHelper.generateGuid()} className="lineItems" onClick={handleClickError(err, section.section.sectionPage)}>
                    <>
                    <span
                        style={{
                            fontSize: "10px",
                            fontWeight: 700,
                            float: "left"
                        }}
                    >{paintSeverityIcon(err.severity)} {err.date}</span>
                    <span style={{ fontSize: "13px", fontWeight: 700 }}>{"  "}</span>
                    <span
                        style={{
                            fontSize: "10px",
                            fontWeight: 700,
                            float: "right"
                        }}
                    >&nbsp; {err.time}</span>
                    <br/>
                    <div style={{ fontSize: "15px",  textAlign: "left" }}>{err.description}</div>
                    </>
                </div>
            )
        }
        return items;
    }


    const handlerOpen = (section:Section) => (statusOpen : boolean) => {

        var globalErrors: Array<ErrorSummaryAFRSection> = JSON.parse(JSON.stringify(errorList));
        var indexCount = 0;        

        for (var index in globalErrors) {
            globalErrors[index].section.sectionIsOpen = false;

            if (statusOpen) {
                globalErrors[index].section.sectionIsOpen = !statusOpen;
            }

            if (globalErrors[index].section.sectionCode === section.sectionCode) {
                globalErrors[index].section.sectionIsOpen = statusOpen;
            }
            indexCount = indexCount + 1;
        }

        if (indexCount > 0) {
            dispatch(updateErrors(globalErrors));
        }
        
    }


    /************** Effects and Events **********************/   
    const handleClickError = (err: Error, page: string) => (event: any) => {
        // Check for user - all the pages are the admin navigator entry ending in A, but is we're not admin then we need to strip the terminal A
        if (userRole !== "ADMIN") {
            if (page.endsWith("A")) {
                page = page.substr(0, page.length - 1);
            }
        }
        var goTo: string = page;
        var tab: string = "";
        if (err.linkTo.length > 0) { goTo = err.linkTo }

        if (err.entityType.length > 0) {
            var table = err.entityType.split("_");
            switch (table[0]) {                
                case enums.UISection.revenues:
                    //Revenues
                    tab = "2";
                    if (table[1] === "2") {tab = "3"}
                    break;
                case enums.UISection.expenditures:
                    //Expenditures
                    tab = "2";
                    break;
                case enums.UISection.affiliatedEntities:
                    //Affiliated Entities
                    tab = "2";
                    break;
            }

        }

        /* Update any deferred change to AFRSlice */
        utilityHelper.saveDeferredChanges(dispatch);

        history.push({
            pathname: goTo,
            state: { entityCode: err.entityCode, entityType: err.entityType, tabId: tab },
        });

    }

    // effects  
    useEffect(() => {
        if (currentAfr && currentEntity) {
            const vc: ValidationContext = {
                afr: currentAfr,
                entity: currentEntity,
                afrEvents: currentEvents,
                pendingTableFacts: pendingTableFacts,
                pendingReplaceTableFacts: pendingReplaceTableFacts,
                dimensionSectionMap: dmap
            };
            /* check if there are error to notify */
            var errors = getValidationsForAfr(vc);
            if (errors && errors.length > 0) {
                dispatch(validateAfr(vc));
            }

        } else {
            dispatch(resetValidationState({}));
        }

    }, [currentAfr, currentEntity, currentEvents]);

    useEffect(() => {
        setShowNotification(displayErrors);
    }, [displayErrors]);

    /* *******************************************/

    return (
        <React.Fragment>
            {totalErrorCount > 0 &&
                (
                    <div className="notification" style={{ position: "relative" }}>
                        <div className="iconSection">
                            <img
                                alt="Notification"
                                src={notificationIcon}
                                onClick={() => toggleNotification()}
                                style={{ cursor: "pointer" }}
                            ></img>
                            <span className={"iconBadge"}>{totalErrorCount.toString()}</span>
                        </div>
                        {showNotification && (
                            <div className="notificationBar">
                                <div className="header">
                                    <div style={{ fontSize: "14px", textAlign: "left", width: "93%" }}>
                                    <h6><b>{utilityHelper.taxonomyTitleFromEnumeration(taxonomyType)} Assistance</b></h6>
                                    </div>
                                    <img alt={"close"}
                                        onClick={() => toggleNotification()}
                                        style={{ width: "5%", cursor: "pointer" }}
                                        src={close}
                                    ></img>
                                </div>
                                {/* Insert here the detail */}
                                <div className="detail" >
                                {errorList.map((i: any, idx : number) => {

                                    return (
                                        <Row key={"errornotesection" + idx} className="my-1">
                                                <Col>
                                                    <React.Fragment>
                                                        
                                                        <NavigationPanelItem
                                                            active={true}
                                                            componentName={i.section.sectionTitle + "  (" + i.sectionErrorCount + ")"}
                                                            open={i.section.sectionIsOpen} handlerOpen={handlerOpen(i.section)} openIcon="bi bi-chevron-down" closeIcon="bi bi-chevron-up" backColor="#2596be" color="white">

                                                            {showErrorSection(i)}
                                                        </NavigationPanelItem>
                                                    </React.Fragment>
                                                </Col>
                                            </Row>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                )}


        </React.Fragment>


    );
}

export default NotificationErrorBySections;
